<template lang="pug">
Fragment
  div.d-flex.justify-content-center( v-if="isEditMode && !ot" )
    b-spinner( variant="secondary" )
  .samtek-page( v-else )
    .samtek-page-header
      .samtek-title-row
        .samtek-back-btn(@click="$router.back()")
          b-icon(icon="arrow-left-short" font-scale="1.6")
        h2.samtek-page-title {{ isEditMode ? 'Editar Orden de Trabajo' : 'Crear Orden de Trabajo' }}
      p.samtek-breadcrumb Inicio / {{ isEditMode ? 'Editar Orden de Trabajo' : 'Crear Orden de Trabajo' }}

    .samtek-content
      OTSection(
        step="01"
        title="Datos del Cliente"
        :open="true"
        :section="'client'"
      )
        div.d-flex
          ClientForm.ot-box(@openSection="setOpenEquipmentSection", :provisoryRut="provisoryRut" :rut_ov="rut_ov" :ov_id="ov_id")
          .card-provisorio(v-if="ot && ot.datos_provisorios")
            .card-provisorio-header Datos provisorios del cliente
            .card-provisorio-body
              p Nombre: {{ ot.datos_provisorios.nombre ? ot.datos_provisorios.nombre : '' }}
              p Rut: {{ ot.datos_provisorios.rut ? ot.datos_provisorios.rut : '' }}
              b-button.samtek-btn-primary(@click="preComplete(ot.datos_provisorios.rut)" v-if="client === null" size="sm").w-100 Pre-Completar
      OTSection(
        step="02"
        v-if="openEquipment === true"
        title="Datos del Equipo"
        :open="true"
        :section="'equipment'"
      )
        EquipmentForm.ot-box(@openSection="setOpenOTSection" :n_serie_ov="n_serie_ov")
      OTForm.ot-box(v-if="equipment && openOT === true"  :ov_id="ov_id")
</template>

<script>
/** @module NewOTIndex
 * Permite crear o editar una orden de trabajo con una secuencia de pasos
 */
import { mapActions, mapGetters, mapMutations } from "vuex";
import OTSection from "./OTSection.vue";
import OTForm from "./OTForm.vue";
import ClientForm from "./ClientForm.vue";
import EquipmentForm from "./EquipmentForm.vue";

export default {
  name: "NewOTIndex",
  components: {
    OTSection,
    OTForm,
    ClientForm,
    EquipmentForm,
  },
  created() {
    const { otId, order_id, rut, n_serie,ov_id } = this.$route.params;
    this.rut_ov = rut;
    this.n_serie_ov = n_serie;
    this.ov_id = ov_id;
    this.isEditMode = !!otId || !!order_id;
    this.fetchOT(otId || order_id);
    this.breadcrumbs = [
      {
        text: "Inicio",
        to: { path: "/" },
      },
      {
        text: "Ordenes de Trabajo",
        to: { path: "/" },
      },
      {
        text: this.isEditMode ? "Editar Orden de Trabajo" : "Crear Orden de Trabajo",
        active: true,
      },
    ];
  },
  data() {
    return {
      isEditMode: false,
      openEquipment: false,
      openOT: false,
      provisoryRut: null,
      rut_ov: null,
      n_serie_ov: null,
      ov_id: null,
    };
  },
  computed: {
    ...mapGetters("OTStore", ["ot"]),
    ...mapGetters("ClientStore", ["client", "sucursal"]),
    ...mapGetters("EquipmentStore", ["equipment"]),
  },
  watch: {
    $route() {
      // Refrescar la página al cambiar entre Editar/Crear OT
      this.$router.go();
    },
    ot(value) {
      if (value.ot) {
        this.openOT = true;
        this.openEquipment = true;
      }
    },
  },
  methods: {
    ...mapActions("OTStore", ["getOT", "editOT"]),
    ...mapMutations("OTStore", ["SET_OT", "SET_EQUIPO"]),
    ...mapMutations("ClientStore", ["SET_CLIENT", "SET_SUCURSAL"]),
    ...mapMutations("EquipmentStore", ["SET_EQUIPMENT"]),
    preComplete(rut) {
      this.provisoryRut = rut;
    },
    setOpenEquipmentSection(value) {
      if (value === true) {
        this.openEquipment = true;
      }
    },
    setOpenOTSection(value) {
      if (value === true) {
        this.openOT = true;
      }
    },
    async fetchOT(otId) {
      if (otId) {
        await this.getOT(otId);
      } else {
        this.SET_OT({ ot: null });
        this.SET_CLIENT({ client: null });
        this.SET_EQUIPMENT({ equipment: null });
        this.SET_EQUIPO({ equipment: null });
        this.SET_SUCURSAL({ sucursal: null });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.samtek-page {
  background-color: #F5F6FA;
  min-height: 100vh;
  padding: 24px 32px;

  @media (max-width: 768px) {
    padding: 16px;
  }
}

.samtek-page-header {
  margin-bottom: 20px;
}

.samtek-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.samtek-back-btn {
  background-color: #FECE2F;
  border-radius: 5px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #23201C;
  flex-shrink: 0;
}

.samtek-page-title {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 1.4rem;
  color: #23201C;
  margin: 0;
}

.samtek-breadcrumb {
  font-family: 'Noto Sans', sans-serif;
  font-size: 0.85rem;
  color: #525252;
  margin: 0 0 0 48px;
}

.samtek-content {
  width: 100%;
}

.card-provisorio {
  margin-top: 0;
  margin-left: 16px;
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  padding: 12px;

  .card-provisorio-header {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 700;
    font-size: 0.85rem;
    color: #23201C;
    margin-bottom: 8px;
  }

  .card-provisorio-body p {
    font-size: 0.82rem;
    color: #525252;
    margin-bottom: 4px;
  }
}
</style>
